import { __assign, __rest } from "tslib";
import React, { forwardRef } from 'react';
// import { IMaskInput } from 'react-imask'
import { PatternFormat } from 'react-number-format';
var handleOnAccept = function (name, onChange) {
    return function (_a) {
        var value = _a.value;
        return onChange({ target: { name: name, value: value } });
    };
};
var TextFieldMask = function (mask) {
    return forwardRef(function (props, ref) {
        var name = props.name, onChange = props.onChange, otherProps = __rest(props, ["name", "onChange"]);
        return (React.createElement(PatternFormat
        // eslint-disable-next-line react/jsx-props-no-spreading
        , __assign({}, otherProps, { name: name, valueIsNumericString: true, format: mask, getInputRef: ref, onValueChange: handleOnAccept(name, onChange) })));
    });
};
export default TextFieldMask;
//# sourceMappingURL=TextFieldMask.js.map